module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "prelims-page",
    attrs: {
      "id": "d57691ac4acf6-d1e445"
    }
  }, [_c('span', {
    attrs: {
      "id": "pagev"
    }
  }, [_c('p', {
    staticClass: "dedication-first"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("For Carol Chase")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("A good friend knows all your stories; a best friend helps you write them")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dba2622","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780106519_epub_ded.vue
// module id = 72
// module chunks = 0